/**
 * This file contains the layout constants for the media library feature
 */

import { DropdownOption } from '@ntv360/component-pantry';
import { TableColumn } from '@shared';
import { COLORS } from '@shared/constants';
import { MediaDetail, MediaLibraryButtons, ModalNavIcon, TechnicalDetail } from '../interfaces';

/** Media type filter dropdown options */
export const MEDIA_TYPE_OPTIONS: DropdownOption[] = [
    { label: 'Images', value: 'images' },
    { label: 'Videos', value: 'videos' },
    // { label: 'Feeds', value: 'feeds' },
];

/** Media Library Table Columns */
export const MEDIA_LIBRARY_TABLE_COLUMNS: TableColumn[] = [
    { field: 'thumbnail', header: 'Thumbnail', width: '120px', type: 'image' },
    {
        field: 'fileName',
        header: 'File Name',
        width: '150px',
        hasRedirect: true,
    },
    {
        field: 'tag',
        header: 'Tag',
        width: '250px',
        type: 'status-copy',
        hasRedirect: true,
    },
    { field: 'size', header: 'Size', width: '200px' },
    { field: 'createdAt', header: 'Upload Date', width: '200px' },
    { field: 'ownerName', header: 'Uploader', width: '200px' },
    {
        field: 'actions',
        header: 'Actions',
        width: '150px',
        type: 'actions',
        actions: [
            { icon: 'eye', name: 'viewDetails', color: COLORS.primary, size: 20 },
            { icon: 'pencil-box', name: 'Edit', color: COLORS.primary, size: 14 },
            { icon: 'copy', name: 'Copy', color: COLORS.primary, size: 20 },
            { icon: 'download', name: 'Download', color: COLORS.primary, size: 20 },
            {
                icon: 'outline-trash',
                name: 'Delete',
                color: COLORS.danger,
                hightlighLabel: true,
                size: 20,
            },
        ],
    },
];

/** Media Details Modal Left Section */
export const MEDIA_DETAILS_LEFT: MediaDetail[] = [
    { label: 'Name', key: 'name' },
    { label: 'Owner', key: 'ownerName', fallback: 'Ncompasstv' },
    { label: 'Role', key: 'createdByClientType' },
];

/** Media Details Modal Right Section */
export const MEDIA_DETAILS_RIGHT: TechnicalDetail[] = [
    { label: 'Duration', key: 'duration', icon: 'duration' },
    { label: 'File Size', key: 'size', icon: 'file-size' },
    {
        label: 'Published By',
        key: 'ownerName',
        icon: 'publisher',
        fallback: 'Ncompasstv',
    },
    {
        label: 'Date Published',
        key: 'createdAt',
        icon: 'file-size',
        pipe: 'date',
        pipeFormat: 'MMMM d, y',
        fallback: 'January 1, 2026',
    },
];

/** Media Details Modal Navigation Icons */
export const MODAL_NAV_ICONS: ModalNavIcon[] = [
    { icon: 'new-tab', action: 'view' },
    { icon: 'lock' },
    { icon: 'settings' },
    { icon: 'outline-trash', action: 'delete', color: 'red' },
    { icon: 'chevron-right', action: 'prev', rotate: 180, checkDisabled: 'isFirst' },
    { icon: 'chevron-right', action: 'next', checkDisabled: 'isLast' },
];

/**
 * Media Library buttons constants
 * - label - The button label
 * - icon - Reference to the sprite file icon
 * - action - The function to invoke when this button is clicked - Must match the function name in your consuming .ts file
 * - variant - The button variant. Please make sure you set the variant based on the button variant. See showcase or storybook */
export const MEDIA_LIBRARY_BUTTONS: MediaLibraryButtons = {
    leftControls: [
        {
            id: 'sort-button',
            label: 'Ascending',
            icon: 'sort',
            action: 'onSortContents',
            variant: 'accent',
            width: 16,
            height: 16,
        },
        {
            label: 'Filter By User',
            icon: 'profile',
            action: 'onOpenFilterByUserModal',
            variant: 'accent',
            width: 14,
            height: 13,
        },
    ],
    rightControls: [
        {
            label: 'Bulk Select',
            action: 'onEnableBulkSelect',
            variant: 'primary',
            disabled: 'isBulkSelectEnabled',
        },
        {
            label: 'Bulk Delete',
            action: 'onBulkDelete',
            variant: 'primary',
            disabled: 'isBulkDeleteEnabled',
        },
    ],
    viewControls: [
        {
            icon: 'grid-view',
            action: 'grid',
        },
        {
            icon: 'list-view',
            action: 'list',
        },
    ],
};
